export const ADD_NAMES = 'ADD_NAMES';
export const ADD_LASTNAME = 'ADD_LASTNAME';
export const ADD_BIRTHDATE = 'ADD_BIRTHDATE';
export const ADD_TYPE_IDENTIFICATION = 'ADD_TYPE_IDENTIFICATION';
export const ADD_IDENTIFICATION = 'ADD_IDENTIFICATION';
export const ADD_RELATION_SHIP = 'ADD_RELATION_SHIP';
export const SET_USER_DATA = 'SET_DEPENDENT_DATA';

type MedicalAppointmentActionType = typeof ADD_NAMES | typeof ADD_LASTNAME | typeof ADD_BIRTHDATE |
    typeof ADD_IDENTIFICATION | typeof ADD_TYPE_IDENTIFICATION | typeof ADD_RELATION_SHIP | typeof SET_USER_DATA

export interface MedicalAppointmentAction {
    type: MedicalAppointmentActionType;
    payload: string | UserDataResponse | Date;
}

export interface Patient {
    identification: string;
    firstName: string;
    lastName : string;
    relationShip: string;
}

export interface PatientRequest {
    identification: string;
}

export interface UserDataResponse {
    identification: string;
    firstName: string;
    lastName: string;
    idPolicy: string;
    birthdate: Date;
    gender: string;
    relationship: string;
    dependants?: Dependant[] | null;
}

export interface DependantData {
    identification: string;
    typeIdentification: string;
    firstName: string;
    lastName: string;
    relationship: string;
    gender: string;
}

export interface Dependant extends DependantData {
    birthdate: Date | null;
}

export interface DependantRequest extends DependantData {
    birthdate: string;
}

export type TableType = {
    valor: string | number | Date | null;
}

export enum TypeIdentification {
    IdentificationCard = "CED",
    Value_IdentificationCard = "Cédula",
    ForeignId = "CE",
    Value_ForeignId= "Cédula extranjero",
    Passport = "PAS",
    Value_Passport = "Pasaporte"
}

export enum Gender {
    Female = "F",
    Male = "M",
    Value_Male = "Masculino",
    Value_Female = "Femenino"
}

export enum Relationship {
    Conyuge = "C",
    Hijos = "H",
    Titular = "T",
    Value_Conyuge = "Cónyuge/Conviviente",
    Value_Hijos = "Hijos/Hijastros",
    Value_Titular = "Titular",
}